import React from 'react';
import { useNavigate } from 'react-router-dom';
import { QrCode } from 'lucide-react';
import { API_BASE_URL } from '../../utils/constants';

export function LandingFooter() {
  const navigate = useNavigate();

  const scrollToSection = (sectionId: string) => {
    const section = document.querySelector(`[data-section="${sectionId}"]`);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => {
        const newSection = document.querySelector(`[data-section="${sectionId}"]`);
        if (newSection) {
          newSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <footer className="bg-[--clinqr-navy] text-[--clinqr-lime] section-padding">
      <div className="container-page">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-[--clinqr-lime]/20 rounded-lg flex items-center justify-center">
                <QrCode className="w-5 h-5 text-[--clinqr-lime]" strokeWidth={2} />
              </div>
              <span className="text-xl font-display">Clinqr</span>
            </div>
            <p className="text-[--clinqr-lime]/70 text-sm max-w-md leading-relaxed">
              Smart QR codes for modern marketing. Create dynamic QR codes that route users
              based on device, location, time, and more.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-display mb-4">Product</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('features')}
                  className="text-sm text-[--clinqr-lime]/70 hover:text-[--clinqr-lime] transition-colors"
                >
                  Features
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('use-cases')}
                  className="text-sm text-[--clinqr-lime]/70 hover:text-[--clinqr-lime] transition-colors"
                >
                  Use Cases
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/pricing')}
                  className="text-sm text-[--clinqr-lime]/70 hover:text-[--clinqr-lime] transition-colors"
                >
                  Pricing
                </button>
              </li>
              <li>
                <a
                  href={`${API_BASE_URL}/v1/docs`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-[--clinqr-lime]/70 hover:text-[--clinqr-lime] transition-colors"
                >
                  API Docs
                </a>
              </li>
              <li>
                <a
                  href={`${API_BASE_URL}/v1/mcp-docs`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-[--clinqr-lime]/70 hover:text-[--clinqr-lime] transition-colors"
                >
                  MCP Docs
                </a>
              </li>
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-sm font-display mb-4">Get Started</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => navigate('/register')}
                  className="text-sm text-[--clinqr-lime]/70 hover:text-[--clinqr-lime] transition-colors"
                >
                  Sign Up Free
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/login')}
                  className="text-sm text-[--clinqr-lime]/70 hover:text-[--clinqr-lime] transition-colors"
                >
                  Sign In
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 border-t border-[--clinqr-lime]/10 text-center">
          <p className="text-[--clinqr-lime]/50 text-sm">
            © {new Date().getFullYear()} Clinqr. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
